module.exports = __webpack_public_path__ + "img/Other GYM.502978bf.svg";